export default __webpack_public_path__ + "static/media/person.6db36d5b.svg";